module.exports = __webpack_public_path__ + "static/img/KR.bed07d15.svg";